import NewsItems from "@components/news-components";
import { setTitle } from "@store/title-store";
import { ErrorIndicator, Loader } from "@ui/indicators";
import { useNewsQuery } from "@lib/news";
import { useLocation } from "react-router-dom";
import { useEffect, FC } from "react";

const itemsPerPage = 16;

const DevelopmentNews: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Новости", href: "/news/help" },
      { title: "Скоро в Личном кабинете", href: pathname },
    ];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isLoading, error, hasNextPage, fetchNextPage } = useNewsQuery({
    limit: itemsPerPage,
    type: "DEVELOPMENT",
  });

  return (
    <>
      {error ? (
        <ErrorIndicator />
      ) : isLoading ? (
        <Loader />
      ) : (
        data?.pages.map((page) => (
          <NewsItems items={page.rows} path="development" />
        ))
      )}
      {hasNextPage && (
        <button className="pagination-button" onClick={() => fetchNextPage()}>
          Показать еще
        </button>
      )}
    </>
  );
};

export default DevelopmentNews;
